interface PilotModule { exports: unknown; }
type PilotFactory = (module: PilotModule, exports: unknown, require: (request: string) => unknown) => void;

function runPilotBundle(modules: Readonly<Record<string, PilotFactory>>, dependencies: Readonly<Record<string, Readonly<Record<string, string>>>>, external: Readonly<Record<string, unknown>>, entry: string): unknown {
    const cache = new Map<string, PilotModule>();
    function load(id: string): unknown {
        if (Object.prototype.hasOwnProperty.call(external, id)) return external[id];
        const cached = cache.get(id);
        if (cached) return cached.exports;
        const initialize = modules[id];
        if (!Object.prototype.hasOwnProperty.call(modules, id) || !initialize) throw new Error('Pilot modülü bulunamadı: ' + id);
        const module: PilotModule = { exports: {} };
        cache.set(id, module);
        try {
            initialize(module, module.exports, request => load(dependencies[id][request]));
        } catch (error) {
            cache.delete(id);
            throw error;
        }
        return module.exports;
    }
    return load(entry);
}
